// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_zeroInvestmentSection__u8gRD {
  background-color: var(--background-color0);
  padding: 6rem 0;
  text-align: center;
}

.styles_sectionTitle__4Qh8Z {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  color: var(--text-color0);
  margin-bottom: 1rem;
}

.styles_divider__FltFb {
  width: 5rem;
  height: 4px;
  background-color: var(--brand-yellow);
  border: none;
  border-radius: 2px;
  margin: 1.5rem auto 3.5rem auto;
}

.styles_goldText__y0DPy {
  color: var(--brand-yellow);
}

.styles_textContrast__Uxeol {
  color: var(--text-color0);
}

.styles_rateContainer__laKTu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2.5rem 0;
  gap: 0.5rem;
}

.styles_rateGiant__Rn4h0 {
  font-size: 8rem;
  font-weight: 900;
  color: var(--brand-yellow);
  line-height: 1;
  letter-spacing: -2px;
}

.styles_rateSubtitle__cShye {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--brand-yellow);
  letter-spacing: 0.1rem;
  text-transform: uppercase;
}

.styles_zeroDescContainer__hOvyK {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-width: 45rem;
  margin: 0 auto;
}

.styles_zeroDescText__bWDhL {
  font-size: 1.15rem;
  color: var(--text-color1);
  line-height: 1.6;
  margin: 0;
}

.styles_highlight__d\\+J-x {
  color: var(--brand-yellow);
}


@media (max-width: 600px) {
  .styles_rateGiant__Rn4h0 {
    font-size: 6rem;
  }
  .styles_rateSubtitle__cShye {
    font-size: 1.1rem;
  }
  .styles_zeroDescText__bWDhL {
    font-size: 1.05rem;
  }
}

.styles_ctaContainer__1xRGR {
  margin-top: 4rem;
  padding: 3rem 2rem;
  background-color: var(--background-color1);
  border: 1px solid rgba(var(--brand-yellow-rgb), 0.15);
  border-radius: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2), 0 0 20px rgba(var(--brand-yellow-rgb), 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  max-width: 45rem;
  margin-left: auto;
  margin-right: auto;
}

.styles_ctaTitle__XRMN5 {
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--brand-yellow);
  letter-spacing: 0.05rem;
  margin: 0;
}

.styles_ctaText__46hp7 {
  font-size: 1.25rem;
  color: var(--text-color0);
  line-height: 1.6;
  margin: 0;
}

.styles_ctaLink__wRM5p {
  color: var(--brand-yellow);
  font-weight: 700;
  text-decoration: underline !important;
  transition: opacity 0.2s ease;
}

.styles_ctaLink__wRM5p:hover {
  opacity: 0.8;
}

.styles_ctaHighlight__cdS3J {
  color: var(--brand-yellow);
}

.styles_ctaButton__tHdLU {
  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);
  color: #fff !important;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 1rem 3rem;
  border-radius: 5rem;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(var(--brand-yellow-rgb), 0.3);
  transition: all 0.3s ease;
  margin-top: 0.5rem;
}

.styles_ctaButton__tHdLU:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(var(--brand-yellow-rgb), 0.5);
}

@media (max-width: 600px) {
  .styles_ctaContainer__1xRGR {
    padding: 2rem 1.5rem;
    margin-top: 3rem;
  }
  .styles_ctaTitle__XRMN5 {
    font-size: 1.4rem;
  }
  .styles_ctaText__46hp7 {
    font-size: 1.1rem;
  }
  .styles_ctaButton__tHdLU {
    padding: 0.8rem 2rem;
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/ZeroInvestmentSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,qDAAqD;EACrD,qBAAqB;EACrB,wFAAwF;EACxF,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2FAA2F;EAC3F,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yDAAyD;EACzD,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE;IACE,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF","sourcesContent":[".zeroInvestmentSection {\n  background-color: var(--background-color0);\n  padding: 6rem 0;\n  text-align: center;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n}\n\n.divider {\n  width: 5rem;\n  height: 4px;\n  background-color: var(--brand-yellow);\n  border: none;\n  border-radius: 2px;\n  margin: 1.5rem auto 3.5rem auto;\n}\n\n.goldText {\n  color: var(--brand-yellow);\n}\n\n.textContrast {\n  color: var(--text-color0);\n}\n\n.rateContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 2.5rem 0;\n  gap: 0.5rem;\n}\n\n.rateGiant {\n  font-size: 8rem;\n  font-weight: 900;\n  color: var(--brand-yellow);\n  line-height: 1;\n  letter-spacing: -2px;\n}\n\n.rateSubtitle {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--brand-yellow);\n  letter-spacing: 0.1rem;\n  text-transform: uppercase;\n}\n\n.zeroDescContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  max-width: 45rem;\n  margin: 0 auto;\n}\n\n.zeroDescText {\n  font-size: 1.15rem;\n  color: var(--text-color1);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.highlight {\n  color: var(--brand-yellow);\n}\n\n\n@media (max-width: 600px) {\n  .rateGiant {\n    font-size: 6rem;\n  }\n  .rateSubtitle {\n    font-size: 1.1rem;\n  }\n  .zeroDescText {\n    font-size: 1.05rem;\n  }\n}\n\n.ctaContainer {\n  margin-top: 4rem;\n  padding: 3rem 2rem;\n  background-color: var(--background-color1);\n  border: 1px solid rgba(var(--brand-yellow-rgb), 0.15);\n  border-radius: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2), 0 0 20px rgba(var(--brand-yellow-rgb), 0.05);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  max-width: 45rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ctaTitle {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: var(--brand-yellow);\n  letter-spacing: 0.05rem;\n  margin: 0;\n}\n\n.ctaText {\n  font-size: 1.25rem;\n  color: var(--text-color0);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.ctaLink {\n  color: var(--brand-yellow);\n  font-weight: 700;\n  text-decoration: underline !important;\n  transition: opacity 0.2s ease;\n}\n\n.ctaLink:hover {\n  opacity: 0.8;\n}\n\n.ctaHighlight {\n  color: var(--brand-yellow);\n}\n\n.ctaButton {\n  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);\n  color: #fff !important;\n  font-weight: bold;\n  font-size: 1.1rem;\n  padding: 1rem 3rem;\n  border-radius: 5rem;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(var(--brand-yellow-rgb), 0.3);\n  transition: all 0.3s ease;\n  margin-top: 0.5rem;\n}\n\n.ctaButton:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(var(--brand-yellow-rgb), 0.5);\n}\n\n@media (max-width: 600px) {\n  .ctaContainer {\n    padding: 2rem 1.5rem;\n    margin-top: 3rem;\n  }\n  .ctaTitle {\n    font-size: 1.4rem;\n  }\n  .ctaText {\n    font-size: 1.1rem;\n  }\n  .ctaButton {\n    padding: 0.8rem 2rem;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"zeroInvestmentSection": `styles_zeroInvestmentSection__u8gRD`,
	"sectionTitle": `styles_sectionTitle__4Qh8Z`,
	"divider": `styles_divider__FltFb`,
	"goldText": `styles_goldText__y0DPy`,
	"textContrast": `styles_textContrast__Uxeol`,
	"rateContainer": `styles_rateContainer__laKTu`,
	"rateGiant": `styles_rateGiant__Rn4h0`,
	"rateSubtitle": `styles_rateSubtitle__cShye`,
	"zeroDescContainer": `styles_zeroDescContainer__hOvyK`,
	"zeroDescText": `styles_zeroDescText__bWDhL`,
	"highlight": `styles_highlight__d+J-x`,
	"ctaContainer": `styles_ctaContainer__1xRGR`,
	"ctaTitle": `styles_ctaTitle__XRMN5`,
	"ctaText": `styles_ctaText__46hp7`,
	"ctaLink": `styles_ctaLink__wRM5p`,
	"ctaHighlight": `styles_ctaHighlight__cdS3J`,
	"ctaButton": `styles_ctaButton__tHdLU`
};
export default ___CSS_LOADER_EXPORT___;
